/**
 * 店铺一览画面 - Reducer
 */

import * as types from '../../actions/shopList/shopListActionTypes';
import { AreaOption, FilterOption, FilterState, SearchParams, Shop } from '../../../pages/ShopList/types';

export interface ShopListState {
  searchParams: SearchParams;
  filters: FilterState;
  shops: Shop[];
  totalCount: number;
  loading: boolean;
  loaded: boolean;
  areaOptions: AreaOption[];
  facilityOptions: FilterOption[];
  serviceOptions: FilterOption[];
}

const initialState: ShopListState = {
  searchParams: {
    area: '',
    keyword: '',
  },
  filters: {
    facilities: [],
    services: [],
  },
  shops: [],
  totalCount: 0,
  loading: false,
  loaded: false,
  areaOptions: [],
  facilityOptions: [],
  serviceOptions: [],
};

export const shopListReducer = (state = initialState, action: any): ShopListState => {
  switch (action.type) {
    case types.SET_SEARCH_PARAMS:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.payload,
        },
      };

    case types.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case types.CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          facilities: [],
          services: [],
        },
      };
    case types.GET_VISITOR_CLUB_OPTIONS_LIST_REQUEST:
      return {
        ...state,
      };

    case types.GET_VISITOR_CLUB_OPTIONS_LIST_SUCCESS:
      return {
        ...state,
        areaOptions: action.payload.areaOptions,
        facilityOptions: action.payload.facilityOptions,
        serviceOptions: action.payload.serviceOptions,
      };

    case types.GET_VISITOR_CLUB_OPTIONS_LIST_FAILURE:
      return {
        ...state,
      };

    case types.GET_VISITOR_CLUB_OPTIONS_LIST_INITIAL:
      return {
        ...state,
        loading: false,
        loaded: false,
        areaOptions: initialState.areaOptions,
        facilityOptions: initialState.facilityOptions,
        serviceOptions: initialState.serviceOptions,
      };

    case types.GET_VISITOR_CLUB_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case types.GET_VISITOR_CLUB_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        shops: action.payload.shops,
        totalCount: action.payload.totalCount,
      };

    case types.GET_VISITOR_CLUB_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
      };

    case types.GET_VISITOR_CLUB_LIST_INITIAL:
      return {
        ...state,
        loading: false,
        loaded: false,
        shops: initialState.shops,
        totalCount: initialState.totalCount,
      };

    default:
      return state;
  }
};

export default shopListReducer;
